module.exports = __webpack_public_path__ + "img/caret.a0825946.svg";